import echarts from 'echarts'

const unitUtils = require('../formatUnit')
const last  = require('lodash/last')

import indicatorGenerator from './indicatorGenerator'
import BS from './bs'

const RISE = '#D4332F'
const FALL = '#258D01'

const tradingTime = {
  timeList(h, m, len, removeStartIndex, removeLen) {
    let res = []
    while(len--) {
      res.push(`${h < 10 ? '0' + h : h}:${m < 10 ? '0' + m : m}`)
      m++
      if(m === 60) {
        h++
        m = 0
      }
    }
    res.splice(removeStartIndex, removeLen)
    return res
  },
  CN() {
    return this.timeList(9, 30, 331, 120, 90)
  },
  HK() {
    return this.timeList(9, 31, 400, 150, 60)
  },
  USA() {
    return this.timeList(9, 31, 390, 0, 0)
  },
  create (region) {
    return tradingTime[region]()
  }
}

function isDef (val) {
  return val !== undefined && val !== null
}

function formatUnit (data, n = 4, str, precision = 2) {
  if(!isDef(data)) return data
  data = data / Math.pow(10, n)
  data = +data.toFixed(precision) === 0 ? 0 : data // 去掉-0
  return str ? data.toFixed(precision) : Number(data.toFixed(precision))
}

function createBaseLine (val) {
  if(!isDef(val)) {
    val = 0
  }
  return Array.apply(null, {length: 1200}).map(function () {
    return val
  })
}

function dateFormat (val, format) {
  val = typeof val === 'number' ? new Date(val) : val
  var o = {
    'M+': val.getMonth() + 1, //month
    'd+': val.getDate(), //day
    'h+': val.getHours(), //hour
    'm+': val.getMinutes(), //minute
    's+': val.getSeconds() //second
  };
  if(/(y+)/.test(format)) format = format.replace(RegExp.$1,
    (val.getFullYear() + '').substr(4 - RegExp.$1.length))
  for(var k in o)
    if(new RegExp('(' + k + ')').test(format))
      format = format.replace(RegExp.$1, RegExp.$1.length == 1
        ? o[k]
        : ('00' + o[k]).substr(('' + o[k]).length))
  return format
}

function genUid (a, b) {
  return `${a}:${b}`
}

/**
 *
 * @param {prise} a
 * @param {base} b
 */
function getColorClass (a, b) {
  a = a - b
  if(a < 0) return 'fall-color'
  if(a > 0) return 'rise-color'
  if(a === 0) return 'draw-color'
}

function getColorStyle (a, b) {
  a = a - b
  if(a < 0) return FALL
  if(a > 0) return RISE
  if(a === 0) return '#666'
}

function getTodayData(min1, lastDay) {
  if(!min1.c.length
    || min1.t[0] - lastDay.TradingDay < 24 * 3600) return
  let a = 0, v = 0, h = -Infinity, l = Infinity
  min1.a.forEach(item => a += item)
  min1.v.forEach(item => v += item)
  min1.h.forEach(item => {
    h = item > h ? item : h
  })
  min1.l.forEach(item => {
    l = item < l ? item : l
  })
  return {
    Time: min1.t[0],
    Open: min1.o[0],
    Close: last(min1.c),
    High: h,
    Low: l,
    Amount: a,
    Volume: v
  }
}

function checkIsRepeat(data) {
  if(!data.t || !data.t.length) return
  let len = data.t.length
  if(data.t[len - 1] !== data.t[(len - 2) / 2]) return
  let mid = (len + 1) / 2
  data.t = data.t.slice(0, mid)
  data.h = data.h.slice(0, mid)
  data.o = data.o.slice(0, mid)
  data.l = data.l.slice(0, mid)
  data.c = data.c.slice(0, mid)
  data.v = data.v.slice(0, mid)
  data.a = data.a.slice(0, mid)
  data.avg = data.avg.slice(0, mid)
  data.totalAmount = data.totalAmount / 2
  data.totalVol = data.totalVol / 2
}

function setTradingFirstBar ({tradingDay, open}) {
  let min1 = this.dataSet['MIN1']
  min1.t.unshift(tradingDay + 9.5 * 3600)
  min1.h.unshift(open)
  min1.l.unshift(open)
  min1.o.unshift(open)
  min1.c.unshift(open)
  min1.a.unshift(0)
  min1.v.unshift(1)
  min1.avg.unshift(open)
}

function createArea (base) {
  return {
    type: 'line',
    smooth: true,
    lineStyle: {
      width: 1,
      color: base + ',1)'
    },
    areaStyle: {
      color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
        offset: 0,
        color: base + ',0.2)'
      }, {
        offset: 1,
        color: base + ',0.03)'
      }])
    }
  }
}

function connectCharts (chartList) {
  echarts.util.each(chartList, function (fromChart) {
    echarts.util.each(chartList, function (toChart) {
      if(fromChart === toChart) return
      fromChart.on('updateAxisPointer', function (params) {
        let payload = toChart.makeActionFromEvent(params)
        let axesInfo = payload.axesInfo || []
        for(let i = axesInfo.length - 1; i >= 0; i--) {
          if(axesInfo[i].axisDim === 'y') {
            axesInfo.splice(i, 1)
          }
        }
        toChart.dispatchAction(payload, true)
      })
    })
  })
}

function getZoomStart(val) {
  return 100 - (48 / val) * 100
}

function calculateMA (data, dayCount) {
  var result = []
  var sum = 0
  data[-1] = 0
  for(var i = 0, len = data.length; i < len; i++) {
    sum += data[i]
    if(i < dayCount - 1) {
      result.push('')
    } else {
      sum -= data[i - dayCount]
      result.push(sum / dayCount)
    }
  }
  delete data[-1]
  return result
}

function createMA (data, d, color) {
  return {
    type: 'line',
    name: 'MA' + d,
    data: calculateMA(data, d),
    symbol: 'none',
    smooth: true,
    color: color,
    lineStyle: {
      width: 1
    }
  }
}

// ========================= MIN1
const MIN1Chart = {
  options(vm) {
    let myData = vm.getMyData()
    checkIsRepeat('mydata', myData)
    const isMin1 = vm.klineType === 'MIN1'
    const precision = vm.regionConfig.precision
    let y0 = this.yAxis(vm, myData)
    let y1 = this.yAxis(vm, myData)
    y0.axisLabel.formatter = val => val.toFixed(precision)
    y0.axisPointer.label.formatter = val => val.value.toFixed(precision)
    y1.axisLabel.formatter = val => formatUnit((val - vm.statistic.PreClosePrice) / vm.statistic.PreClosePrice, -2) + '%'
    y1.axisPointer.label.formatter = val => formatUnit((val.value - vm.statistic.PreClosePrice) / vm.statistic.PreClosePrice, -2) + '%'
    return {
      animation: false,
      grid: vm.topOptions.grid,
      tooltip: {
        trigger: 'axis',
        triggerOn: 'none',
        axisPointer: {
          type: 'cross',
          lineStyle: {
            color: '#6CA6FE'
          },
          snap: false,
          crossStyle: {
            color: '#6CA6FE',
            type: 'solid'
          },
          label: {
            backgroundColor: 'rgba(0, 122, 255, 0.5)'
          }
        },
        transitionDuration: 0,
        formatter: function (val) {
          this.createTitleData(val[0].dataIndex)
          return ''
        }.bind(vm)
      },
      xAxis: {
        type: 'category',
        show: true,
        axisTick: {
          show: false,
        },
        axisPointer: {
          label: {
            show: false
          }
        },
        axisLine: {
          lineStyle: {
            color: '#F5F5F5'
          }
        },
        axisLabel: {
          interval: function (index) {
            if (!vm.klines[vm.klineType]) return
            let {limit, remainder, xMultiple} = vm.klines[vm.klineType]
            if(isMin1) {
              if(limit - remainder === index
                || index === remainder
                || parseInt(limit / 2) === index) {
                return true
              }
            } else {
              return index % xMultiple === remainder
            }
          },
          formatter (val) {
            if(!isMin1) return dateFormat(val * 1000, vm.klines[vm.klineType].dateType)
            val = val.split(':')[0]
            if(vm.region === 'CN') {
              switch(val) {
                case '09': return '09:30'
                case '13': return '11:30/13:00'
                case '14': return '15:00'
              }
            } else if(vm.region === 'HK') {
              switch(val) {
                case '09': return '09:30'
                case '13': return '12:00/13:00'
                case '15': return '16:10'
              }
            } else if(vm.region === 'USA') {
              switch(val) {
                case '09': return '09:30'
                case '12': return '12:30'
                case '15': return '16:00'
              }
            }
          },
          textStyle: {
            color: '#98A0B3',
            fontSize: 10
          }
        },
        data: vm.klineType === 'MIN1' ? vm.MIN1Time : myData.t
      },
      yAxis: [y0, y1],
      series: this.series(vm, myData)
    }
  },
  yAxis (vm, myData) {
    const preClose = vm.statistic.PreClosePrice
    let maxGap = Math.max.apply(null, myData.h.filter(item => item !== '-').length ? myData.h.filter(item => item !== '-') : myData.c.filter(item => item !== '-'))
    let minGap = Math.min.apply(null, myData.l.filter(item => item !== '-').length ? myData.l.filter(item => item !== '-') : myData.c.filter(item => item !== '-'))
    maxGap = Math.abs(maxGap - preClose)
    minGap = Math.abs(minGap - preClose)
    maxGap = Math.max(maxGap, minGap)
    maxGap = maxGap || preClose * 0.05
    return {
      type: 'value',
      axisTick: {
        show: false
      },
      axisLabel: {
        margin: 4,
        inside: true,
        padding: [0, 0, 10, 0],
        fontSize: 12,
        color (val) {
          return getColorStyle(formatUnit(val, 0), formatUnit(preClose, 0))
        }
      },
      axisPointer: {
        label: {
        }
      },
      splitLine: {
        lineStyle: {
          color: '#f5f5f5'
        }
      },
      axisLine: {
        lineStyle: {
          color: '#F5F5F5'
        }
      },
      max () {
        return formatUnit(preClose + maxGap, 0, true, vm.regionConfig.precision)
      },
      min () {
        return formatUnit(preClose - maxGap, 0, true, vm.regionConfig.precision)
      },
      interval: maxGap || 1
    }
  },
  series (vm, myData) {
    let series = [
      Object.assign({}, createArea('rgba(0, 122, 255'), {
        symbol: 'none',
        data: myData.c
      }),
      {
        yAxisIndex: 1,
        symbol: 'none',
        type: 'line',
        lineStyle: {
          width: 0
        },
        data: myData.c
      }
    ]
    !vm.isIndex
      && series.push({
        type: 'line',
        smooth: true,
        symbol: 'none',
        lineStyle: {
          width: 1,
          color: '#E7C25D'
        },
        data: myData.avg
      })
    return series
  }
}

const Value = {
  option(vm) {
    let myData = vm.getMyData()
    let y = this.yAxis(vm, myData)
    y.axisLabel.formatter = val => val.toFixed(3)
    y.axisPointer.label.formatter = val => val.value.toFixed(3)
    return {
      animation: false,
      grid: {
        top: 15,
        left: 0,
        bottom: 21,
        right: 0,
      },
      dataZoom: [{
        type: 'inside',
        start: getZoomStart(myData.c.length),
        end: 100,
        disabled: false,
        preventDefaultMouseMove: false,
        zoomOnMouseWheel: false,
        moveOnMouseMove: true,
        moveOnMouseWheel: false
      }],
      tooltip: {
        trigger: 'axis',
        triggerOn: 'none',
        backgroundColor: 'rgba(235,239,243,0.8)',
        textStyle: {
          color: '#666666'
        },
        borderWidth: 1,
        borderColor: 'rgba(153,174,191,1)',
        axisPointer: {
          type: 'line',
          axis: 'x',
          lineStyle: {
            color: '#6CA6FE'
          },
          snap: false,
          crossStyle: {
            color: '#6CA6FE',
            type: 'solid'
          },
          label: {
            backgroundColor: 'rgba(0, 122, 255, 0.5)'
          }
        },
        transitionDuration: 0,
        formatter: '{b}<br />单位净值: {c}元'
      },
      xAxis: {
        type: 'category',
        show: true,
        axisTick: {
          show: false,
        },
        axisPointer: {
          label: {
            show: true
          }
        },
        axisLine: {
          lineStyle: {
            color: '#F5F5F5'
          }
        },
        axisLabel: {
          interval: 10,
          formatter(val) {
            return val
          },
          textStyle: {
            color: '#999999',
            fontSize: 12
          }
        },
        data: myData.t
      },
      yAxis: y,
      series: this.series(vm, myData)
    }
  },
  yAxis(){
    return {
      type: 'value',
      axisTick: {
        show: false
      },
      axisLabel: {
        inside: true,
        padding: [0, 0, 10, 0],
        fontSize: 12,
        color() {
          return '#666'
        }
      },
      axisPointer: {
        label: {
          show: true
        }
      },
      splitLine: {
        lineStyle: {
          color: '#f5f5f5'
        }
      },
      axisLine: {
        lineStyle: {
          color: '#F5F5F5'
        }
      },
    }
  },
  series(vm, myData) {
    return [
      {
        type: 'line',
        smooth: true,
        lineStyle: {
          width: 1,
          color: 'rgba(0, 122, 255, 1)'
        },
        areaStyle: {
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: 'rgba(0, 122, 255, 0.2)'
          }, {
            offset: 1,
              color: 'rgba(0, 122, 255, 0.03)'
          }])
        },
        symbol: 'none',
        data: myData.c
      }
    ]
  },
}

// ================================== Candle
/**
 * input: 多个一维数组
 * output: 二维数组
 */
function genCandleData () {
  let args = Array.prototype.slice.call(arguments)
  let len = args.length
  let res = []
  args[0].forEach((el, index) => {
    let temp = []
    let i = 0
    while(i < len) {
      temp.push(args[i][index])
      i++
    }
    res.push(temp)
  })
  return res
}

const candle = {
  options(vm) {
    const myData = vm.getMyData()
    if(!myData) return -1
    vm.candleOption = {
      animation: false,
      grid: vm.topOptions.grid,
      tooltip: {
        trigger: 'axis',
        triggerOn: 'none',
        transitionDuration: 0,
        axisPointer: {
          type: 'cross',
          snap: false,
          lineStyle: {
            color: '#6CA6FE'
          },
          crossStyle: {
            color: '#6CA6FE',
            type: 'solid'
          },
          label: {
            backgroundColor: 'rgba(0, 122, 255, 0.5)'
          }
        },
        formatter: function (val) {
          // todo
          this.createTitleData(val[0].dataIndex, val)
          return ''
        }.bind(vm)
      },
      dataZoom: [{
        type: 'inside',
        start: getZoomStart(myData.c.length),
        end: 100,
        disabled: false,
        preventDefaultMouseMove: false,
        zoomOnMouseWheel: false,
        moveOnMouseMove: true,
        moveOnMouseWheel: false
      }],
      xAxis: {
        type: 'category',
        axisTick: {
          show: false
        },
        axisLabel: {
          color: '#8C9295',
          fontSize: 10,
          padding: [0, 22, 0, 0],
          interval: 20,
          formatter (val) {
            return dateFormat(val * 1000, vm.klines[vm.klineType].dateType)
          }
        },
        axisLine: {
          lineStyle: {
            color: '#F5F5F5'
          }
        },
        axisPointer: {
          label: {
            show: false
          }
        },
        data: myData.t
      },
      yAxis: this.yAxis(vm),
      series: this.series(vm, myData)
    }
    return vm.candleOption
  },
  series(vm, myData) {
    let series = [
      {
        type: 'candlestick',
        itemStyle: {
          color: '#D4332F',
          color0: '#258D01',
          borderColor: '#D4332F',
          borderColor0: '#258D01',
        },
        data: genCandleData(
          myData.o, myData.c, myData.l, myData.h
        )
      }
    ]
    if(vm.techType === 'BOLL') {
      series = series.concat(indicatorGenerator.createBOLL(myData.c).series)
    } else {
      series.push(createMA(myData.c, 5, '#076FFD'),
        createMA(myData.c, 10, '#994300'),
        createMA(myData.c, 20, '#D330FF'))
    }
    myData.bs
      && vm.klineType === 'BS'
      && series.push(BS.series(myData.bs))
    return series
  },
  yAxis(vm) {
    return {
      type: 'value',
      axisTick: {
        show: false
      },
      splitLine: {
        show: false
      },
      axisLine: {
        show: false
      },
      interval: Infinity,
      axisPointer: {
        label: {
          formatter (val) {
            return val.value.toFixed(vm.regionConfig.precision)
          }
        }
      },
      axisLabel: {
        inside: true,
        padding: [0, 0, 10, 0],
        showMinLabel: true,
        showMaxLabel: true,
        margin: 3,
        formatter (val) {
          return val.toFixed(vm.regionConfig.precision)
        },
        textStyle: {
          color: '#98A0B3'
        }
      },
      scale: true
    }
  }
}

// =========================== Bottom

const bottom = {
  options(vm) {
    const myData = vm.getMyData()
    const isMin1 = vm.klineType === 'MIN1'
    const techData = this.series({
      type: vm.techType === 'BOLL' || vm.isLikeMin1 ? 'v' : vm.techType,
      myData
    })
    vm.bottomRawData = techData.rawData
    vm.bottomOption = {
      animation: false,
      grid: {
        top: 10,
        left: 0,
        bottom: 0,
        right: 0,
      },
      dataZoom: vm.isLikeMin1 ? null
        : function () {
          let s = getZoomStart(myData.c.length)
          this.candleOption.dataZoom[0].start = s
          this.candleOption.dataZoom[0].end = 100
          this.candleOption.dataZoom[0].type = 'inside'
          this.topChart.setOption(this.candleOption, true)
          return [{
            type: 'inside',
            showDetail: false,
            start: s,
            end: 100,
            preventDefaultMouseMove: false,
            zoomOnMouseWheel: false,
            moveOnMouseMove: false,
            moveOnMouseWheel: false
          }]
        }.call(vm),
      tooltip: {
        trigger: 'axis',
        triggerOn: 'none',
        transitionDuration: 0,
        axisPointer: {
          type: 'cross',
          snap: false,
          lineStyle: {
            color: '#6CA6FE'
          },
          crossStyle: {
            color: '#6CA6FE',
            type: 'solid'
          },
          label: {
            backgroundColor: 'rgba(0, 122, 255, 0.5)'
          }
        },
        formatter (val) {
          return ''
        }
      },
      xAxis: {
        type: 'category',
        axisLine: {
          show: false,
        },
        axisTick: {
          show: false
        },
        axisPointer: {
          label: {
            formatter (val) {
              return dateFormat(
                (isMin1 ? vm.dataSet['MIN1'].t[val.seriesData[0].dataIndex] : val.value) * 1000
                , vm.klines[vm.klineType].labelDateType || vm.klines[vm.klineType].dateType)
            }
          }
        },
        data: isMin1 ? vm.MIN1Time : myData.t
      },
      yAxis: this.yAxis(vm),
      series: techData.series
    }
  },
  yFormatter (type, val, region) {
    if(type === 'v' || type === 'BOLL') return unitUtils.formatUnit(val / region.singleHand, false, true, 0)
    if(type === 'OBV') return unitUtils.formatUnit(val, false, true, 0)
    return formatUnit(val, 0)
  },
  yAxis (vm) {
    return {
      type: 'value',
      axisLine: {
        show: false
      },
      axisTick: {
        show: false
      },
      axisPointer: {
        label: {
          formatter (val) {
            return bottom.yFormatter(vm.techType, val.value, vm.regionConfig)
          }
        }
      },
      splitLine: {
        show: false
      },
      interval: Infinity,
      axisLabel: {
        padding: [0, 0, 10, 0],
        inside: true,
        showMaxLabel: true,
        showMinLabel: true,
        margin: 3,
        formatter (val) {
          return bottom.yFormatter(vm.techType, val, vm.regionConfig)
        },
        textStyle: {
          color: '#98A0B3',
          fontSize: 10
        }
      }
    }
  },
  series ({type, myData}) {
    if(type === 'v') {
      return {
        rawData: null,
        series: [{
          type: 'bar',
          itemStyle: {
            color (params) {
              let index = params.dataIndex
              return myData.c[index] < (myData.c[index - 1] || myData.c[index]) ? FALL : RISE
            }
          },
          data: myData.v
        }]
      }
    }
    let data
    if(type === 'MACD' || type === 'KDJ' || type === 'CCI' || type === 'WR') {
      data = genCandleData(
        myData.o, myData.c, myData.l, myData.h
      )
    }
    if(type === 'RSI' || type === 'BOLL' || type === 'BIAS') {
      data = myData.c
    }
    if(type === 'OBV') {
      data = genCandleData(myData.c, myData.v)
    }
    if(!data) return {series: [], rawData: []}
    return indicatorGenerator['create' + type](data)
  }
}

export default {
  tradingTime,
  createArea,
  connectCharts,
  isDef,
  formatUnit,
  createBaseLine,
  getColorClass,
  getColorStyle,
  getTodayData,
  checkIsRepeat,
  setTradingFirstBar,
  dateFormat,
  genUid,
  getZoomStart,
  calculateMA,
  createMA,
  genCandleData,
  MIN1Chart,
  candle,
  bottom,
  BS,
  Value
}